module.exports = {
  init: function(selector) {
    this.selector = selector;
    this.$container = $(selector);
    var that = this;

    this.$container.find('.comment_form').submit(function() {
      var commentText = that.$container.find('.new_comment').val();

      if( commentText != '' ) {
        $(this).ajaxSubmit({
          dataType: 'json',
          beforeSubmit: function() {
            $.prettyLoader.show();
          },
          success: function(response_data) {
            if(response_data.status > 0) {
              var res = $(response_data.new_comment).hide();
              that.$container.find('.comments').append(res);
              res.slideDown();
              that.$container.find('.new_comment').val('').blur();
            } else {
              $.jGrowl(response_data.message);
            }
            $.prettyLoader.hide();
          },
          error: function(request, txt_status, error) {
            $.jGrowl(txt_status + ", " + error + '.  Contact us if this problem persists');
            $.prettyLoader.hide();
          }
        });
      }
      return false;
    });

    this.$container.on('click', 'a.delete-comment', function() {
      var el = this;
      customConfirm("Are you sure you want to delete this comment?", function() {
        that.destroy($(el));
      })
    })
  },

  destroy: function($comment) {
    var id = $comment.data('comment-id');
    var that = this;

    $.prettyLoader.show();
    $.ajax({
      type: 'POST',
      url: '/comments/'+id+'.json',
      data: {_method: 'delete'},
      dataType: 'json',
      success: function() {
        $.prettyLoader.hide();
        that.$container.find(".comment[data-comment-id="+id+"]")
          .slideUp(function() { $(this).remove() });
      },
      error: function() {
        $.prettyLoader.hide();
        $.jGrowl("Comment deleted");
        trace("Something went wrong")
      }
    });
  }
}



// WEBPACK FOOTER //
// ./public/javascripts/comments.js